// extracted by mini-css-extract-plugin
export default {"aside":"AsideMenu_aside__ZR9qm","title":"AsideMenu_title__mPT8J","userInfoWrapper":"AsideMenu_userInfoWrapper__ljBxj"};